// @mui
import type { BoxProps } from '@mui/material';

import { Box } from '@mui/material';
import { forwardRef } from 'react';

// ----------------------------------------------------------------------

export interface SvgColorProps extends BoxProps {
  src: string;
}

const SvgColor = forwardRef<HTMLSpanElement, SvgColorProps>(
  ({ src, sx, ...other }, ref) => (
    <Box
      className="svg-color"
      component="span"
      ref={ref}
      sx={{
        bgcolor: 'currentColor',
        display: 'inline-block',
        height: 24,
        mask: `url(${src}) no-repeat center / contain`,
        WebkitMask: `url(${src}) no-repeat center / contain`,
        width: 24,
        ...sx,
      }}
      {...other}
    />
  )
);

SvgColor.displayName = 'SvgColor';

export default SvgColor;
